<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Travel Preferences</h1>
                </div>
                <div class="brand-icon" >
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>

            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
                <el-form-item
                prop="travel_preference"
                :required="true"
                class="job_filters_form_select"
            >
              <el-select
                  class="select"
                  v-model="formsData.userForm.travel_preference.value"
                  placeholder="Distance (km)"
                  popper-class="normal-select"
              >
                <el-option
                    v-for="item in travelOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button class="submit_page submit" type="blue" @click="goNext('userForm')"
                        :disabled="formsData.userForm.disabled">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>


<script>
    import {
        onMounted,
        inject,
    } from 'vue';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
        useRoute
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'
    import formValidate from '@/hooks/form/validate/validate'
    import { ElMessageBox } from "@/components/Vendor/Element";
    import SvgIcon from '@/components/Svg/SvgIcon.vue';


    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
            SvgIcon,
        },
        directives: {
        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const $route = useRoute()

            const setPageClassGlobal = inject('setPageClassGlobal');

            const userData = $store.getters.GET_USER_DATA;
            console.log("🚀 ~ setup ~ userData:", userData)
           

           


            const formsDataArray = {
                userForm: {
                    travel_preference: {
                    value: '',
                    validators: [
                        {
                        validator: (rule, formField, callback) => {
                            formValidate.validate(
                                rule,
                                formField,
                                {
                                rule: "travelPreference",
                                },
                                callback,
                                setFormValidation
                            );
                        },
                        },
                    ],
                    },
                }
            };

            const travelOptions = [
                {
                    label: "10 km",
                    value: 10,
                },
                {
                    label: "25 km",
                    value: 25,
                },
                {
                    label: "50 km",
                    value: 50,
                },
                {
                    label: "100 km",
                    value: 100,
                },
                {
                    label: "Any",
                    value: 0,
                },
            ];

            const goBack = () => {

                $router.push({
                    name: 'auth_pharmacist_certifications'
                })
                // $router.push({
                //     name: 'auth_availability_shift_type'
                // })
            };

            const goNext = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {

                        (async () => {
                            try {
                                await $store.dispatch('SAVE_USER_DATA', getFormValues(formName));
                                $router.push({
                                    name: 'auth_travel_preferences_assignment',
                                })
                            } catch (error) {
                                console.log('error submit!!');
                            }
                        })();
                        console.log('submit!!',getFormValues(formName));
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            };

            const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'auth_travel_preferences_assignment',
                    })
                } catch (error) {
                    console.log(error);
                }
            })();
          
        }

            onMounted(() => {
                setPageClassGlobal('global_auth_travel_preferences');
                setFormRefs();
                checkFormValidation('userForm', false);
            });

            const {
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                formsData,
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                goBack,
                goNext,
                travelOptions,
                skip
            }
        },
    }
</script>